// ABOUTME: Shared utility for assigning consistent colors to children across dashboards.
// ABOUTME: Used by both the parent home dashboard and the child dashboard for visual consistency.

// "Keiki card rotation — up to 6 profiles" from the Nalu brand kit's Brand Alignment sheet
// (Nalu and Swinging Stone Design Alignment/Brand Alignment.dc.html). Tint = card background.
// Blue leads because it carries no behavior meaning; sea-teal sits last so it keeps its
// reset/calm meaning on buttons and zones elsewhere.
const CHILD_COLORS = [
  '#E3EBF4', // 1 · Moonlit blue
  '#F9E3D4', // 2 · Coral
  '#F7ECD4', // 3 · Sand-gold
  '#F0E4E6', // 4 · Dusk mauve
  '#E9EDE4', // 5 · Sage stone
  '#DFEEE7', // 6 · Sea-teal
];

// The brand sheet's "dark" tone for the same rotation — used for borders and avatars.
const CHILD_BORDER_COLORS = [
  '#4C6B92', // 1 · Moonlit blue
  '#C05F47', // 2 · Coral
  '#B5853C', // 3 · Sand-gold
  '#8C5F6E', // 4 · Dusk mauve
  '#6E7F5C', // 5 · Sage stone
  '#46776F', // 6 · Sea-teal
];

/**
 * Returns the card background tint for a child based on their zero-based index
 * in the family's ordered children list (ordered oldest to youngest).
 * Cycles through the palette for families with more than 6 children.
 */
export const getChildColor = (index: number): string => {
  return CHILD_COLORS[index % CHILD_COLORS.length];
};

/**
 * Returns the "dark" tone paired with getChildColor's tint at the same index —
 * used for borders and avatar backgrounds, per the brand sheet.
 */
export const getChildBorderColor = (index: number): string => {
  return CHILD_BORDER_COLORS[index % CHILD_BORDER_COLORS.length];
};
